import React from "react";
import { CommonIconProps } from "./types";
import { IconBase } from "./IconBase"; // Import IconBase

export const IconFile: React.FC<CommonIconProps> = (props) => {
  return (
    <IconBase
      iconStyle="solid"
      {...props}
      pathData={
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.19144 22.75C4.58211 22.75 3.27678 21.4403 3.27427 19.823L3.25 4.18619C3.24749 2.56532 4.55429 1.25 6.16717 1.25H12.9695C13.2271 1.25 13.4741 1.35268 13.6564 1.53551L20.4645 8.36329C20.6473 8.5466 20.75 8.79546 20.75 9.05498V19.8184C20.75 21.4375 19.4439 22.75 17.8328 22.75H6.19144ZM18.8043 9.46094L12.5673 3.20594V7.96094C12.5673 8.78936 13.2389 9.46094 14.0673 9.46094H18.8043Z"
          fill="currentColor"
        />
      }
    />
  );
};
